export const FIRST_ACTION = {
  todaysActionId: 1,
  action: 'Walk',
};
